module.exports = __webpack_public_path__ + "img/BINDI 1 GREEN.b230f24.svg";